import { Envelope } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import {
  integrationProviderRegistry,
  type IntegrationConfigProps,
  type IntegrationStatusProps,
} from "../integration_registry.js";

function EmailIcon() {
  return <Envelope size={20} />;
}

function EmailConfigEditor({ config, update }: IntegrationConfigProps) {
  const toEmail = (config.toEmail as string) ?? "";

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="toEmail">Recipient Email</Label>
        <Input
          id="toEmail"
          type="email"
          value={toEmail}
          onChange={e => update({ ...config, toEmail: e.target.value })}
          placeholder="recipient@example.com"
        />
      </div>
    </div>
  );
}

function EmailStatusDisplay({ connected, error }: IntegrationStatusProps) {
  if (connected) {
    return <Badge variant="default">Connected</Badge>;
  }
  return <Badge variant="destructive">{error ?? "Not connected"}</Badge>;
}

integrationProviderRegistry.register({
  type: "email",
  kind: "channel",
  label: "Email",
  icon: EmailIcon,
  ConfigEditor: EmailConfigEditor,
  StatusDisplay: EmailStatusDisplay,
});
